<template>
  <section id="single-schedule">
    <dayone />
    <daytwo />
  </section>
</template>

<script>
import dayone from '@/components/toronto/agenda/dayone.vue';
import daytwo from '@/components/toronto/agenda/daytwo.vue';

export default {
  name: 'Agenda toronto',
  components: {
    dayone,
    daytwo
  },
};
</script>

<style lang="scss" scoped>
  #single-schedule {
    padding: 20px 0 60px !important;
  }
</style>